import React, { useState } from "react";

import * as fromProjects from "store/Projects";

import { a } from "@react-spring/web";
import { useIntersect } from "hooks/useIntersect";
import { useAnimateInTrail } from "hooks/useAnimateInTrail";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

import { Bar } from "./Bar";

interface IProps {
  animationReady: boolean;
  bodyContent: object;
}

export const Timeline: React.FC<IProps> = ({ animationReady, ...props }) => {
  const bodyContent: fromProjects.IContentTimelineSection =
    props.bodyContent as fromProjects.IContentTimelineSection;

  const getNumberOfStages = () => {
    let amount: number = 1;

    bodyContent.content.bars.map((bar) => {
      if (bar.endStage > amount) amount = bar.endStage;
    });

    return amount;
  };

  const [numberOfStages] = useState(getNumberOfStages());

  const getGridLines = () => {
    const gridLines = [];
    for (let i = 0; i <= numberOfStages; i++) {
      gridLines.push(
        <div
          key={i}
          className="line"
          style={{
            backgroundColor: bodyContent.content.lineColor,
          }}
        />
      );
    }
    return gridLines;
  };

  const getStageTitles = () => {
    const stageTitles = [];
    for (let i = 0; i < numberOfStages; i++) {
      stageTitles.push(
        <div
          key={i}
          className="stage"
          style={{
            color: bodyContent.content.stageTextColor,
          }}
        >
          {i + 1}
        </div>
      );
    }
    return stageTitles;
  };

  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const [animateInTrail] = useAnimateInTrail(inView, 3);

  const getBars = () =>
    bodyContent.content.bars.map((bar, index) => (
      <Bar
        animateIn={inView}
        bar={bar}
        numberOfStages={numberOfStages}
        index={index}
        key={index}
      />
    ));

  const wrapperStyles = {
    width: "100%",
    opacity: animateInTrail[0].active,
    transform: animateInTrail[0].active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
    backgroundColor: bodyContent.content.backgroundColor,
  };

  const gridLinesStyles = {
    opacity: animateInTrail[1].active,
  };

  const stageTitlesStyles = {
    opacity: animateInTrail[2].active,
  };

  return (
    <div ref={inViewRef} className="timelineWrapper">
      <a.div style={wrapperStyles}>
        <a.div
          className="flex-container gridLinesWrapper"
          style={gridLinesStyles}
        >
          {getGridLines()}
        </a.div>
        <a.div
          className="flex-container stageTitlesWrapper"
          style={stageTitlesStyles}
        >
          {getStageTitles()}
        </a.div>
        <div className="barsWrapper">{getBars()}</div>
      </a.div>
    </div>
  );
};
